import { SampleImagesComponent } from './../sample-images/sample-images.component';
import { Component, ContentChild, ElementRef, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogContent } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { CropperComponent } from 'angular-cropperjs';
import { ICampaign } from './../../../shared/models/campaign.model';
import { IGTM, ISystemEvent } from './../../../shared/models/events.model';
import { CampaignService, EventsService, UtilService, VariablesService } from './../../../shared/services/';

@Component({
  selector: 'app-image-upload',
  templateUrl: './image-upload.component.html',
  styleUrls: ['./image-upload.component.scss']
})
export class ImageUploadComponent implements OnInit {

  @Input() draft: ICampaign;
  @Input() info;
  croppedImage = {
    fImage: '',
    bImage: ''
  };
  media = {
    fImage: {
      name: '',
      id: 0
    },
    bImage: {
      name: '',
      id: 0
    },
  };
  fileError;
  file = {
    fImage: File = undefined,
    bImage: File = undefined
  };
  isSubmit = false;
  id;
  isSpin = false;
  @ViewChild('imageDialogTemplate', { static: true }) imageDialog: TemplateRef<any>;
  @ViewChild('optionsDialog', { static: true }) optionsDialog: TemplateRef<any>;
  @ViewChild('videoUrlDialog', { static: true }) videoUrlDialog: TemplateRef<any>;
  @ViewChild('cropper') cropper: CropperComponent;
  @ViewChild('fImage', { static: true }) fImage: ElementRef<HTMLInputElement>;
  @ContentChild(MatDialogContent) cropperDialogContent: ElementRef;
  removable = true;

  imgSrc;
  options = {
    aspectRatio: 750 / 430,
    movable: true,
    rotatable: false,
    zoomable: true,
    zoomOnWheel: true,
    dragMode: 'move',
    autoCropArea: true,
    cropBoxResizable: false,
    cropBoxMovable: false,
    guides: false
  };
  type;
  isVideoUrl = false;
  videoUrl;
  isUploadBeneficiary: boolean;
  showPopoverUpload;

  constructor(
    private actRoute: ActivatedRoute,
    public dialog: MatDialog,
    private domSanitizer: DomSanitizer,
    private util: UtilService,
    private vars: VariablesService,
    private campaignService: CampaignService,
    private eventsService: EventsService,
  ) {
    this.getDraft();
  }

  ngOnInit() {
    this.getCampaignType();
    this.util.addCssToGlobal('https://cdnjs.cloudflare.com/ajax/libs/cropper/4.1.0/cropper.min.css');
  }
  /**
   * Get draft details
   */
  getDraft() {
    this.type = this.actRoute.snapshot.queryParams['type'];
    this.vars.draftObs.subscribe((res) => {
      this.draft = res;
      this.checkForId();
      this.checkToUploadBeneficiaryImage();
    });
  }
  /**Get the type of the campaign */
  getCampaignType() {
    this.util.campaignType$.subscribe((res) => {
      if (res) {
        this.type = res;
      }
    });
  }
  /**get id and data to pre populate the fields */
  checkForId() {
    const did = this.actRoute.snapshot.queryParams['did'];
    if (did && this.draft && this.draft.media) {
      this.draft.media.filter((item) => {
        switch (item.display_type_1) {
          case 'leaderboard':
            this.croppedImage.fImage = item.cdn_path;
            this.media.fImage.name = item.file_name;
            this.media.fImage.id = item.id;
            break;
          case 'beneficiary':
            this.croppedImage.bImage = item.cdn_path;
            this.media.bImage.name = item.file_name;
            this.media.bImage.id = item.id;
            break;
        }
      });
    }
  }
  /**Submit the image component*/
  submitButton() {
    if (!this.croppedImage.fImage && !this.croppedImage.bImage) {
      this.isSubmit = true;
    } else {
      this.util.navigateToForm('advance', this.type, this.draft.id);
      // this.gtmPush();
      // this.sendSystemEvent();
    }
  }
  /**Mocking file upload input */
  openFile(id) {
    this.dialog.closeAll();
    if (typeof document !== 'undefined') {
      document.getElementById(id).click();
    }
    // this.getDraft();
  }
  /**File change event for image cropper */
  fileChangeEvent(event: any, id): void {
    const file: File = event.target.files[0];
    if (id === 'fImage') {
      this.file.fImage = file;
      this.media.fImage.name = file.name;
    } else {
      this.file.bImage = file;
      this.media.bImage.name = file.name;
    }
    const imageFile = new Image();
    this.id = event.target.id;
    if (typeof window !== 'undefined') {
      this.imgSrc = this.domSanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(file));
      imageFile.src = window.URL.createObjectURL(file);
    }
    if (event.target.files.length > 0 && id === 'fImage') {
      imageFile.onload = (() => {
        if (imageFile.naturalWidth <= 700 && imageFile.naturalHeight <= 400) {
          this.fileError = {
            message: 'Fundraiser picture should be larger than 700px in width and 400px in height!',
            error: true
          };
        }
      });
      this.openDialog(this.imageDialog);
    } else {
      this.save();
    }
    this.fileError = this.util.onFileChange(event);
  }
  selectFromFacebook() {
    const id = this.util.storage.getProperty('facebook', 'id');
    this.getFaceBookImages(id);
  }
  /**Save video url */
  saveVideoURL() {
    let youtubeid;
    const match = this.videoUrl?.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/);
    if (match && match[2].length === 11) {
      youtubeid = match[2];
      this.isVideoUrl = false;
      const url = 'https://img.youtube.com/vi/' + youtubeid + '/0.jpg';
      this.croppedImage.fImage = url;
      this.closeDialog();
      const payload = {
        'video': this.videoUrl,
        'display_type_1': 'video'
      };
      this.uploadYoutubeVideo(payload);
    } else {
      this.isVideoUrl = true;
    }
  }
  /**Open dialog/modal */
  openDialog(template, event?): void {
    this.closeDialog();
    this.dialog.open(template, {
      // width: '96vw',
      maxWidth: '96vw',
      panelClass: 'round-dialog'
    });
    this.dialog.afterAllClosed.subscribe(() => {
      this.fImage.nativeElement.value = '';
    });
  }
  /**close dialog */
  closeDialog() {
    this.dialog.closeAll();
    this.isSpin = false;
  }
  /**Remove the Image */
  remove(id): void {
    this.file[id] = undefined;
    this.croppedImage[id] = undefined;
  }
  /**Zoom in and out image  */
  zoom(scale) {
    this.cropper.cropper.zoom(scale);
  }
  /**Check if upload the beneficiary image */
  checkToUploadBeneficiaryImage() {
    if (this.draft?.beneficiaryrelation) {
      this.isUploadBeneficiary = this.draft.beneficiaryrelation.info_1.match('friend|family|pet') ? true : false;
    }
  }
  save() {
    this.isSpin = true;
    let data;
    if (this.id === 'fImage') {
      this.croppedImage.fImage = this.cropper.cropper?.getCroppedCanvas()?.toDataURL();
      data = this.cropper.cropper.getData();
    } else {
      this.croppedImage.bImage = this.imgSrc;
      data = this.file.bImage;
    }
    const payload = new FormData();
    const payload1 = new FormData();
    for (const key of Object.keys(data)) {
      payload.append(key, data[key]);
    }
    payload.append('image', this.file[this.id]);
    payload.append('display_type_1', 'leaderboard');
    payload1.append('file', this.file[this.id]);
    this.id === 'fImage' ? this.uploadLeaderBoardImage(payload) : this.uploadBenefiaciaryImage(payload1);
    this.closeDialog();
  }
  /**get Media id */
  getMediaId(mediaType) {
    for (const item of this.draft.media) {
      if (item.display_type_1 === mediaType) {
        return item.id;
      }
    }
  }
  /**Upload Leaderboard Image */
  uploadLeaderBoardImage(payload) {
    if (this.draft && this.draft.id) {
      this.campaignService.uploadImageLeaderboard(payload, this.draft.id).subscribe((res: any) => {
        this.isSpin = false;
        this.util.openSnackBar('Images of kids will be blurred as per Govt Regulation.', 'success');
        this.deleteMedia();
      });
    } else {
      this.campaignService.leaderBoardImage = payload;
    }
  }
  /**Upload benefiaciary Image */
  uploadBenefiaciaryImage(payload) {
    if (this.draft && this.draft.id) {
      this.campaignService.uploadImageBeneficiary(payload, this.draft.id).subscribe((res: any)=> {
        this.util.openSnackBar('Images of kids will be blurred as per Govt Regulation.', 'success');
        this.isSpin = false;
      });
    } else {
      this.campaignService.beneficiaryImage = payload;
    }
  }
  /**Upload youtube video api call */
  uploadYoutubeVideo(payload) {
    if (this.draft && this.draft.id) {
      this.campaignService.uploadYoutubeVideo(payload, this.draft.id).subscribe((res: any) => {
        this.deleteMedia();
      });
    } else {
      this.campaignService.youTubeVideo = payload;
    }
  }
  getDraftById(entityId, draftId, type) {
    this.campaignService.getCampaignDraft(draftId).subscribe((res: any) => {
      this.draft = res.data;
      this.vars.draftObs.next(res.data);
      this.isSubmit = false;
      this.isSpin = false;
    });
  }
  /**Delete leader board image */
  deleteMedia() {
    const mediaId = this.getMediaId('leaderboard');
    if (mediaId) {
      this.campaignService.deletMedia(this.draft.id, mediaId).subscribe(() => {
        this.getDraftById(this.draft.creator_entity_details_id, this.draft.id, this.type);
      });
    } else {
      this.getDraftById(this.draft.creator_entity_details_id, this.draft.id, this.type);
    }
  }
  /**get facebook images */
  getFaceBookImages(id) {
    return this.campaignService.getFacebookImages(id);
  }
  /**Get enity */
  /**
   * ALL THE EVENT TRACKING FUNCTIONS
   */
  sendSystemEvent() {
    const payload: ISystemEvent = {
      eventName: 'start_a_campaign_step2_completed',
      event_type: 'campaign',
      page_name: 'Start a Campaign step2',
      info_1: 'type',
      info_2: this.util.getCampaignTypeFromId(this.draft.parent_cause_id),
      info_3: this.util.storage.get('language') || 'English'
    };
    if (this.draft?.id) {
      payload['event_type_id'] = this.draft?.id;
    }
    this.eventsService.systemEventPush(payload);
  }
  /**GTM data push */
  gtmPush() {
    const dataPush: IGTM = {
      event: 'fundraiser_',
      eventCategory: 'fundraiser',
      eventAction: this.util.getCampaignTypeFromId(this.draft.parent_cause_id),
      eventLabel: 'step2_completed',
      Campaign_cause_id: this.draft.cause_id,
      Campaign_id: this.draft.id,
      Campaign_Type: this.util.getCampaignTypeFromId(this.draft.parent_cause_id)
    };
    this.eventsService.gtmPush(dataPush);
  }

  openSampleImages(e?) {
    this.showPopoverUpload = false;
    const dialogRef = this.dialog.open(SampleImagesComponent, {
      maxWidth: this.util.isMobile ? '90vw' : 'auto'
    });
  }
}
